import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal } from 'antd';
import { CloseOutlined, MinusOutlined } from '@ant-design/icons';
import Util from '../../script/util';
import WEBROOM from '../../store/WebRoom';

class WindowAction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  windowClose = () => {
    if (WEBROOM.isPC()) {
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: <span>您确定要关闭应用吗?</span>,
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          WEBROOM.disconnectRoom().then(() => {
            Util.$interface('_close_window');
          });
        },
      });
    } else if (window.eleEvents) {
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: <span>您确定要关闭应用吗?</span>,
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          WEBROOM.disconnectRoom().then(() => {
            window.eleEvents.quit();
          });
        },
      });
    }
  };
  windowMin = () => {
    if (WEBROOM.isPC()) {
      Util.$interface('_min_window');
    } else if (window.eleEvents) {
      window.eleEvents.minimize();
    }
  };
  render() {
    const { client } = this.props.base;
    return (
      <div>
        {client === 'PC' || client === 'ELE' || client === 'UELE' ? (
          <span className="window-actons noDrag">
            <span className="window-close" onClick={this.windowClose}>
              <CloseOutlined />
            </span>
            <span className="window-min" onClick={this.windowMin}>
              <MinusOutlined />
            </span>
          </span>
        ) : null}
      </div>
    );
  }
}

export default withRouter(WindowAction, { withRef: true });
